// routes
import { PATH_Admin, PATH_BranchSecretory } from '../../../routes/paths';
// components
import SvgColor from '../../../components/svg-color';
// ----------------------------------------------------------------------
const icon = (name) => (<SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);
const ICONS = {
    dashoard : icon('ic_dashboard'),
    analytics: icon('ic_analytics'),
    home: icon('ic_home'),
    report: icon('ic_report'),
    history: icon('ic_history'),
    settings: icon('ic_settings'),
};

const navConfig = [
    //   GENERAL
    //   ----------------------------------------------------------------------
    {
        items: [
           
            {
                title: 'Home',
                path: PATH_BranchSecretory.bs.bsrequestor,
                icon: ICONS.home,

            },
            {
                title: 'Inventory Insights',
                path: '',
                icon: ICONS.analytics,

            },
            {
                title: 'Report', path: PATH_BranchSecretory.reports.reports, icon: ICONS.report,
                children: [
                    { title: 'Summary Report', path: '' },
                    { title: 'Detail Report', path: '' },
                    { title: 'Damaged Tracker', path: '' },
                    { title: 'Missing Tracked', path: ''},
                    { title: 'New Set Replacement Tracker', path: ''},
                    { title: 'Set Transfer Tracker', path:''},
                    { title: 'Additional Item Tracker',path: '' },
                    { title: 'Request Status Tracker',path: '' },
                    { title: 'Request Status Detail Report',path: '' },
                    { title: 'Set Lifecycle With History',path: '' },
                ],
            },
            {
                title: 'Settings',
                path: '',
                icon: ICONS.settings,

            },
        ],
    }
];
export default navConfig;